import { ResetPasswordErrorState } from '../types';
import { enterNewPasswordErrorMessages } from './enter-new-password-error-messages';

export const expiredPassword: ResetPasswordErrorState = {
  httpStatus: '403',
  errorMessage: enterNewPasswordErrorMessages.expiredLink,
};
